export const rangoFechas = {
  desde: "Dal",
  hasta: "Al",
  etiqueta: "Date",
  quitar: "Rimuovi date",
  titulo: "Scegli le date",
  elegirInicio: "Tocca il primo giorno",
  elegirFin: "Ora tocca l'ultimo giorno",
  dias: "giorno | giorni",
  anterior: "Mese precedente",
  siguiente: "Mese successivo",
  cancelar: "Annulla",
  aplicar: "Applica",
};
